import type { Action } from 'state/actions';
import type { QuoteDetailsStateMap } from 'state/quotes/details/details.model';
import { addOrReplaceKey } from 'state/utils/collection';

import * as actionTypes from '../addonManagementForm.actionTypes';

export function quoteDetailsReducer(state: QuoteDetailsStateMap = {}, action: Action): QuoteDetailsStateMap {
  switch (action.type) {
    case actionTypes.ADDON_MANAGEMENT_QUOTE_RECEIVED:
      return action.quote.quoteDetails ? addOrReplaceKey(state, action.quoteId, action.quote.quoteDetails) : state;
    default:
      return state;
  }
}
